import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ActionSheetController, AlertController } from 'ionic-angular';
import { Equipos} from '../../models/maestros';
import { Viaje, Regreso } from '../../models/viaje';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { DataProvider } from '../../providers/data/data';

/**
 * Generated class for the RegresoViajePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-regreso-viaje',
  templateUrl: 'regreso-viaje.html',
})
export class RegresoViajePage {

 
  public showLabel: boolean = true;
  public controlData: any = new Object();
  public bindData: { equipos: Equipos[], allViajes: Viaje[], viajes: Viaje[] } = { equipos: null, allViajes:null, viajes: null};

  public regresoViajeForm: FormGroup;
  public imagen: string;
  public imagen2: string;

  constructor(public navCtrl: NavController, public navParams: NavParams, private data: DataProvider,
    public actionSheetCtrl: ActionSheetController, formBuilder: FormBuilder, public alertCtrl: AlertController) {

      this.regresoViajeForm = formBuilder.group({
        equipo: ['', Validators.required],
        viaje: ['', Validators.required],
        litros: ['', Validators.required],
        litrosformula: ['', Validators.required],
        kilometraje: [''],
        observacion: [''],
        consumo: [''],
        imagen: [''],
        imagen2: [''],
      });


  
      this.data.getEquipos().subscribe(e => {
        if(this.data.todosSectores){
          console.log("Todos los Sectores");
          this.bindData.equipos = e.filter(eq => eq.idcategoriaequipo == 1);
        } else {
          console.log("Filtro Sectores: ",this.data.filtroSectores);
          let aux: Array<any> = this.data.filtroSectores;
          this.bindData.equipos = e.filter(eq => eq.idcategoriaequipo == 1 && this.sectorOk(aux,eq.idsector));
          //this.bindData.equipos = e.filter(eq => eq.idcategoriaequipo == 1);
        }
        console.log("Equipos Filtrados",this.bindData.equipos);
      });
  
      /*this.data.getAllviajes().subscribe(e => {
        this.bindData.allViajes = e.filter(vi => 1==1); //vi.kminicial != null
      });*/

      this.data.getAllviajes().subscribe(e => {
        this.bindData.allViajes = e
      });

  }


  
  public sectorOk(sectoresPermitidos: Array<any>, idsector){

    var rta = sectoresPermitidos.filter(function(number) {
      return number == idsector;
    })

    console.log('lucky',rta);
    if(rta.length>0){
      //console.log(true);
      return true;
    }else{
      //console.log(false);
      return false;
    }  
  }

  public selectedEquipo: Equipos;
  public selectedViaje: Viaje;


  ionViewDidLoad() {
    console.log('ionViewDidLoad RegresoViajePage');
  }

  public equipoChanged(EquipoSel: string) {
    let EqAux:Equipos[] = this.bindData.equipos.filter(a => a.codigo == EquipoSel);
    if(EqAux.length>0){
      this.selectedEquipo = EqAux[0];
      console.log("ID Equipo",this.selectedEquipo.id);
      this.bindData.viajes = this.bindData.allViajes.filter(v => v.idtractor == this.selectedEquipo.id && v.kminicial>0 && v.kmfinal == null);  
      
      if(this.bindData.viajes.length>0){
        this.selectedViaje = this.bindData.viajes[0];
        this.regresoViajeForm.controls.viaje.setValue(this.selectedViaje.id);
        this.regresoViajeForm.controls.kilometraje.setValue(this.selectedViaje.kminicial);
        this.showLabel = true;
      }else{
        this.selectedViaje = null;
        this.regresoViajeForm.controls.viaje.setValue(null);
        this.regresoViajeForm.controls.kilometraje.setValue(null);
      }
    } else {
      this.selectedEquipo = null;
      this.selectedViaje = null;
      this.regresoViajeForm.controls.viaje.setValue(null);

      //jhuck
      this.regresoViajeForm.controls.litrosformula.setValue(null);
      this.regresoViajeForm.controls.litros.setValue(null);
      this.regresoViajeForm.controls.consumo.setValue(null);
      this.regresoViajeForm.controls.kilometraje.setValue(null);
    }
    
  }

  public changeFormula(){
    let formula: string = this.regresoViajeForm.controls.litrosformula.value;
    let litros: number = eval(formula);
    this.regresoViajeForm.controls.litros.setValue(litros);
    let consumo: number;
    console.log("Km Inicial",this.selectedViaje.kminicial);
    let kms: number = this.regresoViajeForm.controls.kilometraje.value - this.selectedViaje.kminicial;
    consumo = (litros / kms)*100;
    this.regresoViajeForm.controls.consumo.setValue(consumo.toFixed(2));
  }

  public grabarDatos() {

    let msjeError: string = '';
    if(this.selectedEquipo == null){
      msjeError = msjeError + "Falta Elegir el equipo ";
    }
    if(this.selectedViaje == null){
      msjeError = msjeError + "No hay viaje ";
    }
     // Validación para asegurar de que el kilometraje sea mayor que el inicial
  if (!(this.regresoViajeForm.controls.kilometraje.value > this.selectedViaje.kminicial)) {
    msjeError = msjeError + "El kilometraje ingresado no es mayor al kilometraje inicial.";
  }
    // if(!(this.regresoViajeForm.controls.litros.value > 0)){
    //   msjeError = msjeError + "Falta Litros ";
    // }

    if(msjeError!=''){
      const alert = this.alertCtrl.create({
        title: 'Faltan Datos',
        subTitle: msjeError,
        buttons: ['OK']
      });
      alert.present();
      return;
    }

    let result: Regreso = new Regreso;
    
    result.idequipo = this.selectedEquipo.id;
    result.idviaje = this.selectedViaje.id;
    result.kmfinal = Number(this.regresoViajeForm.controls.kilometraje.value);
    // result.litrosformula = this.regresoViajeForm.controls.litrosformula.value;
    // result.litros = this.regresoViajeForm.controls.litros.value;
    result.observacion = this.regresoViajeForm.controls.observacion.value;
    result.sincronizado = false;
    result.errorSincro = null;
    result.fechaSincro = null;
    result.imageData = this.controlData.imageData;
    result.imageData2 = this.controlData.imageData2;

    //console.log("resultado a enviar", result, JSON.stringify(result));

    //Valida km.
    this.data.getParams().subscribe(e => {
      var kmsbloqueo = 0;
      var kmsalerta = 0;

      for(let i=0;i<e.length;i++){
        if(e[i].nombre=='KmsBloqueoDespacho'){
          kmsbloqueo = e[i].valor;
        }
        if(e[i].nombre=='KmsAlertaDespacho'){
          kmsalerta = e[i].valor;
        }
      }

      console.log('kmsbloqueo',kmsbloqueo);
      console.log('kmsalerta',kmsalerta);
      console.log('kilometraje final',result.kmfinal );
      console.log('kilometraje equipo ',this.selectedEquipo.kilometraje);

      if(result.kmfinal-this.selectedEquipo.kilometraje > kmsbloqueo){
        const alert = this.alertCtrl.create({
          title: 'Error',
          subTitle: 'El kilometraje ingresado supera los ' +kmsbloqueo+ ' kms. respecto a la última medición realizada del equipo',
          buttons: ['OK']
        });
        alert.present();
        return;
      }else{
        
        this.data.addRegresoViaje(result).subscribe(e => {
          let grabacion  = e;
          console.log("Resultado Grabacion",grabacion);
          if(grabacion['ok']){
            for(let i=0;i<this.bindData.allViajes.length;i++){
              if(this.bindData.allViajes[i].id==result.idviaje){
                this.bindData.allViajes[i].kmfinal = result.kmfinal;
                i=100000000;
              }
            }
            const alert = this.alertCtrl.create({
              title: 'OK',
              subTitle: 'Se guardó el cierre de Viaje',
              buttons: ['OK']
            });
            alert.present();
            this.limpiarControles();
            this.data.sincronizarDatos().subscribe();
          }
        });
        

      }
    }); 


    

  }

  public limpiarControles(){
    this.regresoViajeForm.controls.equipo.setValue(null);
    this.regresoViajeForm.controls.viaje.setValue(null);
    this.regresoViajeForm.controls.litros.setValue(null);
    this.regresoViajeForm.controls.litrosformula.setValue(null);
    this.regresoViajeForm.controls.kilometraje.setValue(null);
    this.regresoViajeForm.controls.observacion.setValue(null);
    this.regresoViajeForm.controls.imagen.setValue(null);
    this.regresoViajeForm.controls.imagen2.setValue(null);
    
  }


  imageFilePath_change(evt) {
    console.log("event de change", evt, evt.target);
    this.attachFile(evt)
      .then(data => this.controlData.imageData = data)
      .catch(error => console.log("Error when trying to save the image", error));
  }

  imageFilePath_change2(evt) {
    console.log("event de change", evt, evt.target);
    this.attachFile(evt)
      .then(data => this.controlData.imageData2 = data)
      .catch(error => console.log("Error when trying to save the image", error));
  }

  attachFile(fileInput: any) {
    return new Promise((resolve, reject) => {
      let destination: any = {};

      let file: File = fileInput.target.files[0];

      if (!file) return;

      if (!destination) destination = {};

      destination.filename = file.name;
      destination.size = file.size;

      let reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = function () {

        destination.data = reader.result;

        //removes the HTML prefix
        let searchText = "base64,";
        var idx = destination.data.indexOf(searchText);
        if (idx > -1)
          destination.data = destination.data.substring(idx + searchText.length);

        resolve(destination);
      };

      reader.onerror = function (error) {
        reject(error);
      };
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/regreso-viaje/regreso-viaje.ts